import axios from 'src/api/Api';
import {
    TERRITORY_CREDIT_SUCCESS,
    TERRITORY_CREDIT_FAILURE,
    SAVE_TERRITORY_CREDIT_SUCCESS,
    SAVE_TERRITORY_CREDIT_FAILURE,
} from 'src/pages/orders/redux/actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getTerritoryCredit(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/territorycredit?`;
    
    const params = convertObjectToQueryParams({
        sstRef: action.payload,
    });

    let finalUrl = url + `${params}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);
        yield put({ type: TERRITORY_CREDIT_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload
        });
        yield put({
            type: TERRITORY_CREDIT_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* saveTerritoryCredit(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/saveterritorycredit?`;

    try {
        const result = yield axios.post(url, action.payload)
            .then((response) => response.data);
        yield put({ type: SAVE_TERRITORY_CREDIT_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SAVE_TERRITORY_CREDIT_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
